"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stepper = exports.inputWrapper = exports.input = exports.actionIcon = exports.actionButton = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var _stepper = require("../js/stepper");
var _variables = require("./variables");
/* eslint-disable import/prefer-default-export */

var stepper = _ref => {
  var appearance = _ref.appearance;
  return /*#__PURE__*/(0, _core.css)("display:", appearance === _stepper.appearances.wide ? 'flex' : 'inline-flex', ";flex-flow:row nowrap;align-items:center;");
};
exports.stepper = stepper;
var inputVariants = appearance => {
  switch (appearance) {
    case _stepper.appearances.cleanThin:
    case _stepper.appearances.thin:
      return 'max-width: 48px;';
    case _stepper.appearances.wide:
      return "width: 100%;";
    default:
      return '';
  }
};
var inputWrapper = _ref2 => {
  var appearance = _ref2.appearance;
  return /*#__PURE__*/(0, _core.css)("display:inline-block;margin:8px;> div{font-weight:bold;text-align:center;}", inputVariants(appearance));
};
exports.inputWrapper = inputWrapper;
var input = _ref3 => {
  var fontSize = _ref3.fontSize,
    appearance = _ref3.appearance,
    isInvalid = _ref3.isInvalid;
  return /*#__PURE__*/(0, _core.css)("font-size:", fontSize, ";font-weight:bold;text-align:center;appearance:none;&::-webkit-outer-spin-button,&::-webkit-inner-spin-button{appearance:none;margin:0;}&[type='number']{-moz-appearance:textfield;}", (appearance === _stepper.appearances.clean || appearance === _stepper.appearances.cleanThin) && "\n      ".concat(isInvalid ? "\n      border-top: 0;\n      border-left: 0;\n      border-right: 0;\n      border-radius: 0;\n      " : 'border: 0;', "\n\n      &:hover,\n      &:focus,\n      &:disabled {\n        ").concat(isInvalid ? "\n            border-top: 0;\n            border-left: 0;\n            border-right: 0;\n          " : "\n            border: 0;\n            box-shadow: none;\n        ", "\n      }\n\n      ").concat(isInvalid && "\n        &:focus {\n          box-shadow: inset 0 -2px 0 -1px ".concat(_variables.inputErrorBorderColor, ";\n        }\n      "), "\n    "));
};
exports.input = input;
var actionButton = exports.actionButton = {
  name: "yvrfp8",
  styles: "padding:8px;appearance:none;border:0;background:transparent;cursor:pointer;&:disabled{cursor:not-allowed;}"
};
var actionIcon = _ref4 => {
  var size = _ref4.size,
    isDisabled = _ref4.isDisabled;
  return /*#__PURE__*/(0, _core.css)("color:", isDisabled ? _feBrary.tokens.colors.interactive.base.disabled : _feBrary.tokens.colors.interactive.base.default, ";height:", size, ";width:", size, ";transition:150ms color ease-in;", !isDisabled && "\n  &:hover {\n    color: ".concat(_feBrary.tokens.colors.interactive.base.hover, ";\n  }\n    "));
};
exports.actionIcon = actionIcon;